import { TabPane } from "reactstrap";
import { LI, UL } from "../../../../../AbstractElements";
import { CommonContentType } from "../../../../../Types/LatterBoxType";
import EmailContent from "./EmailContent";

const CommonContent:React.FC<CommonContentType> = ({tableId,contentData}) => {
  return (
    <TabPane tabId={tableId}>
      <div className="mail-body-wrapper">
        <UL>
          {contentData.map((data,i)=>(
            <LI className="inbox-data" key={i}>
              <EmailContent data={data} ids={i}/> 
            </LI>
          ))}
        </UL>
      </div>
    </TabPane>
  );
};

export default CommonContent;
